import script from "./Add.vue?vue&type=script&setup=true&lang=ts"
export * from "./Add.vue?vue&type=script&setup=true&lang=ts"

import "./Add.vue?vue&type=style&index=0&id=7173b52f&lang=scss"

const __exports__ = script;

export default __exports__